module.exports = __webpack_public_path__ + "img/peerpal-graduway-logo.a9b2aa0a.svg";